<template>
  <UIModal v-model="rent.$state.announceModalOpen" @closed="emit('close')">
    <template #header>
      <slot name="header" />
    </template>
    <template #default>
      <slot name="default" />
    </template>
    <template #footer>
      <slot name="footer" />
    </template>
  </UIModal>
</template>

<script lang="ts" setup>
import { useRentEventStore } from '~/stores/rent-event-store';

const emit = defineEmits(['close']);

const rent = useRentEventStore();
</script>
